import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'moment';
import 'MagnificPopup';
import * as moment from 'moment';
import * as numeral from 'numeral';
import { wcagOptions } from "./wcag";
require('datatables.net');
require('datatablesResponsive');

export class dealsDetailed{
	private $scope: any = $('[data-fullpage-deals]');
	$dealsFilterContainer: any = $('.deals-filter--container');
	$dealsShowMore: any        = $('.deals-show--more');
	$moreDealsContent: any     = $('.more-deals--container');
	$dealsDatatable: any;
	$tableInitialized:string   = 'window.datatable.initialized';
	$destCities:Array<any> = [];
	$currency:string;
	private wcag = new wcagOptions();

	dealsInit(): void {
		let _self =  this;

		// show component if js enabled
		_self.$scope.addClass('shown');
	}

	/**
	 * Retrieve url parameter value
	 * - for country code
	 * @param  {any} sParam [description]
	 */
	getUrlParameter(sParam:any): any{
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
				sURLVariables = sPageURL.split('&'),
				sParameterName:any,
				i:any;

				if (sPageURL.length < 1) {
					return false;
				}

		for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');

				if (sParameterName[0] === sParam) {
						return sParameterName[1] === undefined ? false : sParameterName[1];
				}
		}
	}

	/**
	 * Initialize deals button handlers
	 * - show more deals buttons
	 * - deals trip type buttons
	 * @return {any} [description]
	 */
	dealsButtonHandlers(): void {
		let _self = this;

		_self.$dealsShowMore.find('a').click(function(e:any) {
			 e.preventDefault();
			 _self.$moreDealsContent.fadeIn(100);
		});

		_self.$dealsFilterContainer.find('.trip-type a').click(function(evt: any) {
			evt.preventDefault();
			_self.$dealsFilterContainer.find('.trip-type a').removeClass('selected');
			$(this).addClass('selected');
		});
	}

	/**
	 * Initialize search column for datatables
	 * - does not initialize the country selector column (initialized on promise() only)
	 * @return {any} [description]
	 */
	dealsSelect(data:any): void {
		let _self = this;
		let dataTable:any = _self.$dealsDatatable;

		let $fromCountrySelect       = _self.$scope.find('#datatable--country-select');
		let $toDestCitySelect: any = _self.$scope.find('#datatable--destination-select');
		let $dealsDeptCity: any      = _self.$scope.find('.departureCity');
		let $dealsCabin: any         = _self.$scope.find('.deals-cabin');
		let $cabinClassSelector      = _self.$scope.find('#datatable--cabin-select');
		const bannerDealsContainer:any = _self.$scope.find('[data-banner-deals]');
		let $destCity = _self.$scope.find('[data-dest-city]');
		
		let $tripTypeBtns            = [
		_self.$scope.find("#datatable--triptype-return"),
		_self.$scope.find("#datatable--triptype-oneway")
		];
		let $getCountryCode:any      = _self.getUrlParameter('countrycode');
		let $getOriginCountryCode:any      = _self.getUrlParameter('origincountrycode');
		let $defCountry = _self.$scope.find('[data-default-country]');

		// if country code params presentlet $defCountry = _self.$scope.find('[data-default-country]');
		if ($getCountryCode) {
			$fromCountrySelect.val($getCountryCode);
		}else if($getOriginCountryCode){
			$fromCountrySelect.val($getOriginCountryCode);
		}

		// populate deals option from dataset
		let $rawCitiesOptions:any = _self.getDealsOptions(data);
		let $citiesOptions:any = $rawCitiesOptions.map((el:any, i:number) => {
			return {text: el.name, value: el.url}
		});

		// initialize selectize on from country selector
		$fromCountrySelect.selectize({
			options: $citiesOptions,
			onInitialize: function() {
				_self.wcag.selectizeInputAria($fromCountrySelect[0].selectize);
				// set selectize to default value specified in hidden input
				if($getOriginCountryCode && ($citiesOptions.filter(e => e.value === $getOriginCountryCode).length > 0))
				{
					$fromCountrySelect[0].selectize.setValue($getOriginCountryCode, true);
					 dataTable.column(7).search($getOriginCountryCode).draw();
				}
				else{
					$fromCountrySelect[0].selectize.setValue($defCountry.val(), true);
					// filter table using specified default value
					dataTable.column(7).search($defCountry.val()).draw();
				}
				
				
			},
			onChange: function(value:any) {
				// get current filtered option
				let curOption:any = $fromCountrySelect[0].selectize.options[value];
				let deepLinkSearch:any = _self.$scope.find('input#ddl').val();
				$destCity.val('');
				// clear all images on change before populating
				_self.$scope.find('[data-display-image]').attr({
					'srcset': ''
				});

				// if deep link hidden input is detected, do not clear other search params
				// after search is completed, remove deep link hidden input so that it
				// will not affect subsequent searches
				if (!deepLinkSearch) {
					if (curOption) {
						bannerDealsContainer.removeClass('hidden');
						// reset all other selectize filters on changing fromCountry
						$toDestCitySelect[0].selectize.setValue('All');
						$cabinClassSelector[0].selectize.setValue('All');
						// filter table using updated specified value
						dataTable.column(7).search(curOption.value).draw();
					} else {
							dataTable.column(7).search('not-available').draw();
							bannerDealsContainer.addClass('hidden');
					}
				} else {
					// remove deeplinkinput
					_self.$scope.find('input#ddl').remove();
				}

				// recalculate datatable width on changing src country
				// - resolves alignment issue on mobile (android)
				// - MHCOMDIGI-594
				dataTable.columns.adjust().responsive.recalc();
			},
			selectOnTab: true,
			//sortField: 'text'
		});

		// format destcities array into selectize friendly array
		// from [val,val,val]
		// to [{text:val, value:val}, {text:val, value:val}, {text:val, value:val}]
		function formatToSelectizeOption(data:any) {
			let destObj:Array<any> = []; // reset destobj
			$.each(data, (i:number, el:any) => {
				destObj.push({
					text: el,
					value: el
				});
			});

			return destObj;
		}

		let destCitiesObj:Array<any> = [];
		destCitiesObj = _self.$destCities; // run once on init

		$(document).on('rebuild.destcities', function(){
			destCitiesObj = _self.$destCities; // run on change

			$toDestCitySelect[0].selectize.clearOptions();
			$toDestCitySelect[0].selectize.addOption(destCitiesObj);
			$toDestCitySelect[0].selectize.setValue('All');
		});

		// initialize selectize on from country selector
		$toDestCitySelect.selectize({
			options: destCitiesObj,
			onInitialize: function() {
				let value:any = $toDestCitySelect.find('option:first-child').val();
				if (value.toLowerCase() !== 'all') {
				dataTable.column(1).search(value).draw();
			} else {
				dataTable.column(1).search('').draw();
			}
			},
			onFocus: function() {
				$dealsDeptCity.find('.booking-form--title').addClass('input-filled');
				$dealsDeptCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$toDestCitySelect.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$toDestCitySelect.parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function(value:any) {
				$dealsDeptCity.find('.booking-form--title').addClass('input-filled');
				$dealsDeptCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
				// search data table using country value returned from selectize
				if (value.toLowerCase() !== 'all') {
					dataTable.column(1).search(value).draw();
				} else {
					dataTable.column(1).search('').draw();
				}
			},
			onBlur: function() {
				let $fromLocationChange = $toDestCitySelect.find('option:selected').text();
				if ($fromLocationChange == '') {
					$dealsDeptCity.find('.booking-form--title').removeClass('input-filled');
					$dealsDeptCity.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$dealsDeptCity.find('.booking-form--title').addClass('input-filled');
					$dealsDeptCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			selectOnTab: true,
		//	sortField: 'text'
		});
		$toDestCitySelect[0].selectize.setValue('All');

		// initialize selectize on cabin class selector
		$cabinClassSelector.selectize({
			onInitialize: function() {
				let value:any = $cabinClassSelector.find('option:first-child').attr('value');
				$cabinClassSelector.parent().find('.booking-form--title').addClass('input-filled');
				$cabinClassSelector.parent().find('.selectize-control.single .selectize-input').addClass('select-filled');
				if (value.toLowerCase() !== 'all') {
				dataTable.column(3).search(value).draw();
			} else {
				dataTable.column(3).search('').draw();
			}
			},
			onFocus: function() {
				$dealsCabin.find('.booking-form--title').addClass('input-filled');
				$dealsCabin.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$cabinClassSelector.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$cabinClassSelector.parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function(value:any) {
				$dealsCabin.find('.booking-form--title').addClass('input-filled');
				$dealsCabin.find('.selectize-control.single .selectize-input').addClass('select-filled');
				// search data table using country value returned from selectize
				if (value.toLowerCase() !== 'all') {
					if(value==="FIRST"){
						value = "Business Suite";
					}
					dataTable.column(9).search("^" + value + "$", true, false, true).draw();
			} else {
				dataTable.column(9).search('').draw();
			}
			},
			onBlur: function() {
					$dealsCabin.find('.booking-form--title').addClass('input-filled');
					$dealsCabin.find('.selectize-control.single .selectize-input').addClass('select-filled');
			},
			sortField: 'text'
		});
		$('.deals-cabin .selectize-input input').attr('readonly','readonly');

		// initialize onload & click handler on trip type buttons
		for (var i=0, len=$tripTypeBtns.length; i<len; i++) {
			// set on load
			if ($tripTypeBtns[i].hasClass('selected')) {
				dataTable.column(4).search('').draw();
			}

			// click handler
			$tripTypeBtns[i].on('click', function(ev:any) {
					// search data table using country value returned from selectize
					dataTable.column(4).search(this.dataset.searchParam).draw();
			});
		}

		// trigger table complete event
		$(window).trigger(_self.$tableInitialized);
	}

	/**
	 * Initialize dealsLightBox on each popup item link
	 * - retrieve popup info via data-attributes in link
	 * - populate info to the popup
	 * - attach magnific popup to the link item
	 */
	dealsLightBox(reInit:boolean = false): void {
		let _self = this;
		let $openPopupLink:any = $('.open-popup-link');
		let _scope = $('.deals-container.detailed-container .dataTables_wrapper tbody tr');

		// unbind openPopup handlers if re-initialized
		if (reInit) {
			$openPopupLink.unbind();
		}
		$openPopupLink.on('click', function() {
			let $dealsItem:any = $(this);
			_self.populatePopupData($dealsItem);
		});

		$openPopupLink.magnificPopup({
			type:'inline',
			midClick: true,
			callbacks: {
					afterClose: function() {
							$('.more-deals a').blur();
							$('.deals-error--validation').hide();
							$('.infant-booking--error').hide();
							$('.ticket-adult--input').val('1');
							$('.ticket-child--input').val('0');
							$('.ticket-infant--input').val('0');
							$('.ticket-mob-child--input').val('0');
							$('.ticket-mob-adult--input').val('1');
							$('.ticket-mob-infant--input').val('0');
							$('.total-nos').html('1');
							$('.group-booking').hide();
							$('.ticket-teenager--input').val('0');
							$('.ticket-mob-teenager--input').val('0');
							$('.total-nos-sidetrip').html('1');	
							$(".ticket-nos-btn").removeAttr('disabled');
							$(".mobile-ticketnos--btn").removeAttr('disabled');
					}
			} // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		});

		if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
			// unbind openPopup handlers if re-initialized
			if (reInit) {
				$openPopupLink.unbind();
				_scope.unbind();
			}

			// for mobile table row
			_scope.on('click', function() {
				let $dealsItem:any = $(this);

				$dealsItem.find('.open-popup-link').trigger("click");
			});

			// // for mobile top banner deal
			$openPopupLink.on('click', function() {
				let $dealsItem:any = $(this);
				_self.populatePopupData($dealsItem);
			});

			$openPopupLink.magnificPopup({
				type:'inline',
				midClick: true,
				callbacks: {
						afterClose: function() {
								$('.more-deals a').blur();
								$('.deals-error--validation').hide();
								$('.infant-booking--error').hide();
								$('.ticket-adult--input').val('1');
								$('.ticket-child--input').val('0');
								$('.ticket-infant--input').val('0');
								$('.ticket-mob-child--input').val('0');
								$('.ticket-mob-adult--input').val('1');
								$('.ticket-mob-infant--input').val('0');
								$('.total-nos').html('1');
								$('.group-booking').hide();
								$('.ticket-teenager--input').val('0');
								$('.ticket-mob-teenager--input').val('0');
								$('.total-nos-sidetrip').html('1');
								$(".ticket-nos-btn").removeAttr('disabled');
								$(".mobile-ticketnos--btn").removeAttr('disabled');
								
						}
				} // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
			});
		}
	}

	populatePopupData($dealsItem:any): void {
		let $dealsFromCountryName: any   = $('#datatable--country-select')[0].selectize.getValue();
		let $dealsFromIATA: any          = $dealsItem.attr('data-deals-from-iata');
		let $dealsToCityName: any        = $dealsItem.attr('data-deals-destCity');
		let $dealsToCountryName: any     = $dealsItem.attr('data-deals-destCountry');
		let $dealsToIATA: any            = $dealsItem.attr('data-deals-to-iata');
		let $dealsCurrencyType: any      = $dealsItem.attr('data-deals-currency');
		let $dealsTicketPrice: any       = $dealsItem.attr('data-deals-amount');
		let $dealsCabinClass: any        = $dealsItem.attr('data-deals-cabin');
		let $dealsCabinClassText: any    = $dealsItem.attr('data-deals-cabin-hidden');
		let $dealsTripType: any          = $dealsItem.attr('data-deals-triptype');
		let $dealsTrip: any          	 = $dealsItem.attr('data-deals-trip');
		let $dealsTravelStartPeriod: any = $dealsItem.attr('data-deals-travelstartperiod');
		let $dealsTravelEndPeriod: any   = $dealsItem.attr('data-deals-travelendperiod');
		let $dealsTravelTnc: any         = $dealsItem.attr('data-deals-travelTnc');
		let $dealsToCityCode: any        = $dealsItem.attr('data-deal-destCityCode');
		let $dealsfromCity: any          = $dealsItem.attr('data-deal-fromCity');
		let $dealsfromCityCode: any      = $dealsItem.attr('data-deal-fromcitycode');
		let $dealsfromCountry: any       = $dealsItem.attr('data-deal-fromCountry');

		let $dealsPopup:any = $('.deals-popup');

		let $dealsRetTitle: any 				 = $dealsPopup.find('.dep-return--title .ret-title');
		let $dealRetDate: any 					 = $dealsPopup.find('.calendar-container .returnDate');
		let $dealCalendar: any 					 = $dealsPopup.find('.calendar-container');


		
		let isUkCitySelectedForIbeSearch: boolean = false;
		let ukCities: any;
        let $isEnableCNN: any = $('#isEnableCNN');
        if (($isEnableCNN.val() != 'null') && ($isEnableCNN.val() != '0') && ($isEnableCNN.val() != '')) {
            ukCities = ($('[data-teenager-cities]').data('teenager-cities') != 'null' && $('[data-teenager-cities]').data('teenager-cities') != '' && $('[data-teenager-cities]').data('teenager-cities') != undefined) ? $('[data-teenager-cities]').data('teenager-cities').split(','): [];
        }
        else {
            ukCities = [];
        }		
			if (ukCities.includes($dealsfromCityCode) || ukCities.includes($dealsToCityCode)) {
					$('#passenger-details--deals .teenager-cat').css('display', 'block');
					$('#passenger-details--deals .is-uk').css('display', 'block');
					$('#passenger-details--deals .isnt-uk').css('display', 'none');
					isUkCitySelectedForIbeSearch = true;
				} else {
					$('#passenger-details--deals .isnt-uk').css('display', 'block');
					$('#passenger-details--deals .teenager-cat').css('display', 'none');
					$('#passenger-details--deals .is-uk').css('display', 'none');
					isUkCitySelectedForIbeSearch = false;			
				}
		
		
		// toggle oneway trip
		if ($dealsItem.attr('data-deals-trip') !== "Return") {
			$dealsRetTitle.hide();
			$dealRetDate.hide();
			$dealCalendar.addClass('oneWayTrip').removeClass('returnTrip');
		} else {
			$dealsRetTitle.show();
			$dealRetDate.show();
			$dealCalendar.addClass('returnTrip').removeClass('oneWayTrip');
		}

		let $dealsNowDate        : any = new Date();
		let $dealsTodayDate      : any = new Date($dealsNowDate.getFullYear(), $dealsNowDate.getMonth(), $dealsNowDate.getDate(), 0, 0, 0, 0).toISOString();
		let $dealsDepartureDateMoment: any = moment(new Date($dealsTravelStartPeriod).toISOString()).format('YYYYMMDDhhmm');
		let $dealsTodayDateMoment    : any = moment($dealsTodayDate).format('YYYYMMDDhhmm');
		let $ibeTodayDateMoment      : any = moment($dealsTodayDate).format('DD MMM YYYY');
		let $dealsTravelStartDate    : any;

		if ($dealsDepartureDateMoment < $dealsTodayDateMoment) {
			$dealsTravelStartDate =  $ibeTodayDateMoment;
		} else {
			$dealsTravelStartDate =  $dealsTravelStartPeriod;
		}

		$dealsPopup.find('.dep-return--title').find('.date-form--title').addClass('input-filled');
		$dealsPopup.find('.city-country--list.from .city-name').html($dealsfromCity);
		$dealsPopup.find('.city-country--list.from .country-name').html($dealsfromCountry);
		$dealsPopup.find('.city-country--list.from .city-name').attr("data-code",$dealsfromCityCode);
		$dealsPopup.find('.city-country--list.from .iata').html('('+$dealsFromIATA+')');
		$dealsPopup.find('.city-country--list.to .city-name').html($dealsToCityName);
		$dealsPopup.find('.city-country--list.to .country-name').html($dealsToCountryName);
		$dealsPopup.find('.city-country--list.to .city-name').attr("data-code", $dealsToCityCode);
		$dealsPopup.find('.city-country--list.to .iata').html('('+$dealsToIATA+')');
		$dealsPopup.find('.currency-price .currency-name').html($dealsCurrencyType);
		$dealsPopup.find('.currency-price .price-amount').html($dealsTicketPrice);
		$dealsPopup.find('.cabin-class--type').html($dealsCabinClass);
		$dealsPopup.find('#cabin-class-hidden').html($dealsCabinClassText);
		$dealsPopup.find('.trip-type').html($dealsTripType);
		$dealsPopup.find('.departureDate').val($dealsTravelStartDate);
		$dealsPopup.find('.departureDate').datepicker( 'option', 'minDate', new Date($dealsTravelStartDate));
		$dealsPopup.find('.returnDate').datepicker( 'option', 'minDate', new Date($dealsTravelStartDate));
		$dealsPopup.find('.returnDate').val($dealsTravelEndPeriod);
		$dealsPopup.find('.departureDate').datepicker( 'option', 'maxDate', new Date($dealsTravelEndPeriod));
		$dealsPopup.find('.returnDate').datepicker( 'option', 'maxDate', new Date($dealsTravelEndPeriod));
		$dealsPopup.find('.tc-content').html($dealsTravelTnc);
	}

	getDealsData(url?:string): any {
		let _self = this;
		let dealsTable:any = $('[data-deals-datatable]');
		let dataUrl:string = _self.$scope.attr('data-deals-get-url');

		if (url) {
			dataUrl = url; // replace url if provided as
		}

		let getDealsData = $.Deferred();

		$.get(dataUrl).done((data:any) => {
			var jsonData = data;
			if (typeof data !== 'object') {
				jsonData = JSON.parse(data);
			}
			getDealsData.resolve(jsonData);
		}).fail((error:any) => {
			getDealsData.reject(error);
		});

		return getDealsData.promise();
	}

	/**
	 * [getDealsOptions description]
	 * get unique cities from entire raw dataset
	 * @param  {object} data [raw data]
	 * @return {any}         [filtered array of cities]
	 */
	getDealsOptions(data:any):any {
		let rawData:any = $.makeArray(data);
		let $listCities:Array<any> = [];
		let $filteredListCities:any = [];

		rawData.map((el:any) => {
			return $listCities.push(el.fromCity);
		});

		$listCities.map((el:any, i:number) => {
			let elemExists:number = $filteredListCities.findIndex((el2:any) => {
				return el2.name === el.name;
			});

			if (elemExists < 0) {
				$filteredListCities.push(el);
			}
		});

		return $filteredListCities;
	}

	setTopDeals(): void {
		let _self = this;
		const filteredData:any = $.makeArray(_self.$dealsDatatable.rows( { filter : 'applied'} ).data());
		const bannerDealsContainer:any = _self.$scope.find('[data-banner-deals]');
		const bannerDealsContainerMob:any = _self.$scope.find('[data-banner-deal-mob]');
		const bannerDeals:any = _self.$scope.find('[data-banner-deal-item]');

		if (filteredData.length) {
			bannerDealsContainer.removeClass('hidden');
			bannerDealsContainerMob.removeClass('hidden');
			const sortedData:any = filteredData;


			// add loading class to deal banners
			bannerDeals.each(function(i:number, el:any){
				let $el = $(el);
				$el.addClass('loading');
			});

			sortedData.sort((a:any, b:any) => {
				// multi-dimensional sort
				// https://stackoverflow.com/questions/9175268/javascript-sort-function-sort-by-first-then-by-second
				if (a.priority > b.priority) {
					return 1;
				} else if (a.priority < b.priority) {
					return -1;
				}

		    // else go to the 2nd item
		    if (a.price < b.price) {
		    	return -1;
		    } else if (a.price > b.price) {
		    	return 1
		    } else { // nothing to split them
		    	return 0;
		    }
			});


			const topData = sortedData.slice(0,3);

			bannerDeals.each(function(index:number, el:any){
				let $el = $(el);
				let i:number = index;

				$el.removeClass('hidden');

				// set index to first item of top 3
				// when setting mobile item
				if (el.hasAttribute('data-banner-deal-mob')) {
					i = 0;
				}

				// display params
				let dispPromoShow  :any = $el.find('[data-display-promo]');
				let dispPromoPerc  :any = $el.find('[data-display-promo-percentage]');
				let dispDestCity   :any = $el.find('[data-display-destcity]');
				let dispDestCountry:any = $el.find('[data-display-destcountry]');
				let dispTripType   :any = $el.find('[data-display-triptype]');
				let dispCabinType  :any = $el.find('[data-display-cabin]');
				let dispCurrency   :any = $el.find('[data-display-currency]');
				let dispPrice      :any = $el.find('[data-display-price]');
				let dispStartPeriod:any = $el.find('[data-display-startdate]');
				let dispEndPeriod  :any = $el.find('[data-display-enddate]');
				let dispImage      :any = $el.find('[data-display-image]');
				let dispPopupLink  :any = $el.find('[data-popup-link]');

			if (topData[i]) {

				// set display values
				dispPromoPerc.text(topData[i].discount);
				if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
					// mobile (only show first discount tag if exists)
					if (i === 0 && topData[i].discount.length) {
						dispPromoShow.show();
					} else {
						dispPromoShow.hide();
					}
				} else {
					if (topData[i].discount.length) {
						dispPromoShow.show();
					} else {
						dispPromoShow.hide();
					}
				}

				dispDestCity.text(topData[i].toCity.name);
				dispDestCountry.text(topData[i].toCountry.countryName);
				dispTripType.text(topData[i].packageTypeLabel);
				dispCabinType.text(topData[i].travelClassLabel);
				dispCurrency.text(topData[i].currency);
				dispPrice.text(numeral(topData[i].price).format('0,0'));
				dispStartPeriod.text(topData[i].travelStartDateLabel);
				dispEndPeriod.text(topData[i].travelEndDateLabel);
				dispImage.attr({'srcset': topData[i].imgPath});

				// popup params
				dispPopupLink.attr({
					'data-deals-destCity': topData[i].toCity.name,
					'data-deals-destCountry': topData[i].toCountry.countryName,
					'data-deal-destcitycode': topData[i].toCity.url,
					'data-deal-fromcity': topData[i].fromCity.name,
					'data-deal-fromcitycode': topData[i].fromCity.url,
					'data-deal-fromcountry': topData[i].fromCountry.countryName,
					'data-deals-currency': topData[i].currency,
					'data-deals-amount': topData[i].price,
					'data-deals-cabin': topData[i].travelClassLabel,
					'data-deals-cabin-hidden': topData[i].travelClass,
					'data-deals-triptype': topData[i].packageTypeLabel,
					'data-deals-trip': topData[i].packagetype,
					'data-deals-travelstartperiod': topData[i].travelStartDate,
					'data-deals-travelendperiod': topData[i].travelEndDate,
					'data-deals-to-iata': topData[i].toCity.url,
					'data-deals-from-iata': topData[i].fromCity.url,
					'data-deals-travelTnc': topData[i].tnc
				});
			} else {
				$el.addClass('hidden');
			}

			// 500ms delay to cater for image buffering
			setTimeout(function(){
				$el.removeClass('loading');
			}, 500);
			});
		} else {
			bannerDealsContainer.addClass('hidden');
			bannerDealsContainerMob.addClass('hidden');
		}
	}

	compare(a:any, b:any) {
		// Use toUpperCase() to ignore character casing
		const bandA = a.text.toUpperCase();
		const bandB = b.text.toUpperCase();
	  
		let comparison = 0;
		if (bandA > bandB) {
		  comparison = 1;
		} else if (bandA < bandB) {
		  comparison = -1;
		}
		return comparison;
	  }
	setDestCities(rawData:any): void {
		let _self = this;
		let alltext:any = _self.$dealsFilterContainer.attr('data-all-text');

		// append new cities into array
		$.each(rawData, (i:number, el:any) => {
			_self.$destCities.push({text:el['toCity']['name'], value:el['toCity']['name']});
		});

		// remove duplicates
		_self.$destCities = $.uniqueSort(_self.$destCities);
		_self.$destCities.sort(_self.compare);
		_self.$destCities.unshift({text: alltext , value:'All'}); // reset array
		$(document).trigger('rebuild.destcities');
	}

	setCurrencyType(rawData:any): void {
		let _self = this;
		// MHCOMDIGI-564:
		// if data is present, set currency value
		// else do nothing
		let $dealsFromCountryName: any   = $('#datatable--country-select').val();
		if($dealsFromCountryName == ''  || $dealsFromCountryName == 'null'  || rawData.length <= 0){
			let countrycodeurl:string ='';
			if (window.location.hostname === 'localhost' && window.location.port == '5000') {
				countrycodeurl = '/dummy-data/countrycode.json';
			}
			else {
				countrycodeurl = '/content/dam/mas/json/countrycode.json';
			}
			$.get(countrycodeurl)
			.done((data:any) => {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
				var url_params = window.location.pathname.split('/');
				var site_edition = url_params[1];
				var data_countries = data.Countries;
			   for (var i = 0; i < data_countries.length; i++) {
				   if(site_edition ==  data_countries[i].Code.toLowerCase()){
					   _self.$currency = data_countries[i].Currency;
					   break;
				   }
				}
				if(_self.$currency == null || _self.$currency == ''){
					_self.$currency = 'USD';
				}
			})
			.fail((error:any) => {
			});

		}
		else if (rawData.length) {
			_self.$currency = rawData[0].currency;
		}
		else{
			// do nothing
		}
	
	}

	setTableHeaderCurrency(): void {
		let _self = this;
		let dataTable:any = _self.$dealsDatatable;
		let dealsTable:any = $('#deals-country--list');
		let fromText = dealsTable.attr('data-deals-from');
		const filteredData:any = $.makeArray(dataTable.rows( { filter : 'applied'} ).data());

		let currencyTh:any = dataTable.column(2).header();

		// update class currency type
		_self.setCurrencyType(filteredData);

		// update table header from value
		$(currencyTh).text(fromText + ' ' + _self.$currency);
	}

	

	/**
	 * Initialize deals datatable plugin
	 * - for desktop view only
	 * - event handler for redrawing table
	 */
	dealsTable(rawData:any): void {
		let _self = this;
		let dealsTable:any = $('#deals-country--list');
		let fromText = dealsTable.attr('data-deals-from');
		let buttonText = dealsTable.attr('data-btn-text');
		let tableHeaders = JSON.parse(dealsTable.attr('data-datatable-headers'));
		let tableCurrency = _self.$currency;
		let getURLPath:string = _self.$scope.attr('data-deals-lang');
		let $getDestCityName:any      = _self.getUrlParameter('destcityname');
		let $destCity = _self.$scope.find('[data-dest-city]');
		let destSortOrderName='';
		$destCity.val($getDestCityName);
		console.log("getURLPath: " +getURLPath);
		const sortedDestData:any = rawData;
		
		if($destCity.val()!=='' && $destCity.val()!=='false'){
			destSortOrderName = 'customNumber';
		}
		
			
		/*var namesType = $.fn.dataTable.absoluteOrder( [
			{ value: 'Jakarta', position: 'top' }]
		 );*/

		 /*sortedDestData.sort((a:any, b:any) => {
			
			if (a.toCity.name == "Penang") {
				return 1;
			} else {
				return -1;
			}
		});*/

	//	var nameType = $.fn.dataTable.absoluteOrder( 'Penang' );
		  
		function getDestCities()
		{
			return  ','+ $getDestCityName;
		}

		$.fn.dataTableExt.oSort["customNumber-asc"] = function (a:any, b:any) {

				if (a.indexOf(getDestCities())>-1)
				{ 
				  return -1;
				}
				if (b.indexOf(getDestCities())>-1)
				{
					return 1;
				}
				if (a == b)
				{
				 return 0;
				}
	
				return (a < b) ? -1 : 1;
			
			
		}
		$.fn.dataTableExt.oSort["customNumber-desc"] = function (a:any, b:any) {


			if (a.indexOf(getDestCities())>-1)
			{ 
			  return 1;
			}
			if (b.indexOf(getDestCities())>-1)
			{
				return -1;
			}
			if (a == b)
			{
			 return 0;
			}

			return (a < b) ? 1 : -1;
		  
		}

		_self.$dealsDatatable = dealsTable.DataTable({
			data: rawData,
      		deferRender: true,
			bLengthChange: false,
			// order: [[1, 'asc']],
			responsive: {
				details: false,
				breakpoints: [
				{ name: 'desktop',  width: Infinity },
				{ name: 'tablet-l', width: 1200 },
				{ name: 'tablet-p', width: 767 },
				{ name: 'mobile-l', width: 480 },
				{ name: 'mobile-p', width: 320 }
				]
			},
			"columns": [
					{
						"title": "toCity",
						"data":  function(row:any, type:string, val:any, meta:string ){
							return row['toCity']['name'] + ',' + row['toCity']['url'];
										}
					},
					{ "title": tableHeaders['to'],
						"data": function(row:any, type:string, val:any, meta:string ){
							return '<span class="city-name">' + row['toCity']['name'] +
										 '</span><div style="display: none" class="country-search-field">' +
										 row['toCity']['name'] + ', ' + row['toCity']['url'] +
										 '</div><span class="country">' + row['toCountry']['countryName'] + '</span>';
										}
					},
					{ "title": fromText + " " + tableCurrency,
						"data": function(row:any, type:string, val:any, meta:string){
							return '<span class="from-price">' + row['price'] + ' <small style="font-size: 0.6em">' + row['currency'] + '</small></span>';
						}
					},
					{ "title": tableHeaders['class'],
						"data": function(row:any, type:string, val:any, meta:string){
								return row["travelClassLabel"] + '<div class="hidden" aria-hidden="true">' + row["travelClass"] + '</div>';
						}
					},
					{ "title": tableHeaders['packagetype'],
						"data": function(row:any, type:string, val:any, meta:string){
								return row["packageTypeLabel"] + '<div class="hidden" aria-hidden="true">' + row["packagetype"] + '</div>';
						}
					},
					{ "title": tableHeaders['bookbef'],
						"data": function(row:any, type:string, val:any, meta:string){
							return '<div class="book-before">' + row['bookBeforeLabel'] + '</div>';
						}
					},
					{ "title": tableHeaders['travelperiod'],
						"data": function(row:any, type:string, val:any, meta:string ){
							return '<div class="travel-period date-one" ><span>' + row['travelStartDateLabel'] +
										 '</span><span>-</span><span>' +
										 row['travelEndDateLabel'] +
										 '</span></div>' + 
										 '<div class="travel-period date-two"><span>' + row['travelStartDate1Label'] +
										 '</span><span>-</span><span>' +
										 row['travelEndDate1Label'] +
										 '</span></div>' +
										 '<div class="travel-period date-three"><span>' + row['travelStartDate2Label'] +
										 '</span><span>-</span><span>' +
										 row['travelEndDate2Label'] +
										 '</span></div>';
						}
					},
					{
						"title": "fromCountry",
						"data": "fromCountry.src"
					},
					{ "title": tableHeaders['moredeals'],
						"data": function(row:any, type:string, val:any, meta:string ){
							let dealsBtn:any = $('<a class="btn-secondary open-popup-link">'+buttonText+'</a>');
							let travelEndDate = row['travelEndDate'];
							if(row['travelEndDate2']!=undefined)
							{
								travelEndDate = row['travelEndDate2'];
							}
							else if(row['travelEndDate1']!=undefined)
							{
								travelEndDate = row['travelEndDate1'];
							}
							dealsBtn.attr({
								'href': '#deals-popup',
								'data-lightbox': 'more-deals',
								'data-deals-destcity': row['toCity']['name'],
								'data-deals-destcountry': row['toCountry']['countryName'],
								'data-deals-currency': row['currency'],
								'data-deals-amount': row['price'],
								'data-deals-cabin': row['travelClassLabel'],
								'data-deals-cabin-hidden': row['travelClass'],
								'data-deals-triptype': row['packageTypeLabel'],
								'data-deals-trip': row['packagetype'],
								'data-deals-travelstartperiod': row['travelStartDate'],
								'data-deals-travelendperiod': travelEndDate,
								'data-deal-destcitycode': row['toCity']['url'],
								'data-deal-fromcity': row['fromCity']['name'],
								'data-deal-fromcitycode': row['fromCity']['url'],
								'data-deal-fromcountry': row['fromCountry']['countryName'],
								'data-deals-to-iata': row['toCity']['url'],
								'data-deals-travelTnc': row['tnc'],
								'data-deals-from-iata': row['fromCity']['url']
							});

							return '<div class="more-deals">' + dealsBtn[0].outerHTML + '</div>';
						}
					},
					{ "title": tableHeaders['class'],
					"data": function(row:any, type:string, val:any, meta:string){
							return row["travelClassLabel"];
					}
				},
			],
			aoColumnDefs: [
				
				{
					'bSortable': false,
					'aTargets': [2] // disable sorting on this column (1) == price column
				},{
					'bSortable': false,
					'aTargets': [8] // disable sorting on this column (7) == button column
				},
				{
					'targets': [7],
					'visible': false
				},
				{
					'targets': [0],
					'visible': false
				},
				{
					'targets': [9],
					'visible': false
				},
				{
                    "sType": destSortOrderName,
                    "bSortable": true,
                    "aTargets": [0]
                    
                }
			],
			language: {
          'url': '/content/dam/mas/json/datatable-lang/'+getURLPath+'.json'
      },
      initComplete: function(settings:any, json:any) {
      	// init deep link parsing on datatable init
				_self.parseDeepLink();
      }
		});

		

		// event handler for re-drawing table data
		// reinitialize deals lightbox whenever datatable is redrawn
		// reset table currency
		// reset top deals items
		dealsTable.on('draw.dt', function(e:any){

			// update from currency value based on filtered dataset
			_self.setTableHeaderCurrency();
			// update top deals based on current table state
			_self.setTopDeals();

			$('.travel-period span:contains("undefined")').each(function(){
					$(this).parent().hide();
			});

			_self.dealsLightBox(true);
			let $getReturnDateVal: any = $('.deals-container.detailed-container .dataTable .travel-period');
			$getReturnDateVal.each(function(){
				if($(this).find('span:nth-child(3)').is(':empty')){
					$(this).find('span:nth-child(2)').hide();
				}
			});
		});
	
	}
	
	
	/**
	 * data table behavior effects
	 * @return {any} [description]
	 */
	tableBehaviorEffects(): void {
		let _self = this;
		let tableEl:any = $('#deals-country--list');
		let dealsSelector:any = $('.deals-selector');
		// let tablePos = tableEl.offset();
		// let tablePagination = tableEl.find('.dataTables_paginate a');

		// on table load:
		// - check number of pages (hide pagination if only one page visible)
		// - add event handler to scroll to top of table when page data changes
		$(window).on(_self.$tableInitialized, function(){
			hideTableNavigation(tableEl);

			tableEl.on('draw.dt', function(e:any){
				let tablePos:number = dealsSelector.offset().top;

				hideTableNavigation(tableEl);

				// $('html, body').animate({
				// 	scrollTop: tablePos
				// });
			});

		});


		// hide pagination if only one page of results shown
		// 1 result = 3 links (prev, 1, next)
		function hideTableNavigation(tableEl:any) {
			let tablePaginationContainer:any = tableEl.parent().find('.dataTables_paginate');
			let tablePagination              = tablePaginationContainer.find('a');

			if (tablePagination.length < 4) {
				tablePaginationContainer.fadeOut();
			} else {
				tablePaginationContainer.fadeIn();
			}
		}
	}

	/**
	 * parse deep link params and filter datatable accordingly
	 *
	 * possible params options:
	 * - ddl: deals deep link
	 * - bBef: book before date (YYYYMMDD)
	 * - fromLoc: from location (3 letter country code)
	 * - toLoc: to location (city name)
	 * - cabin: cabin type (F/B/E)
	 * - tripType: trip type (R/O)
	 */
	parseDeepLink(): void {
		let _self = this;
		let params = _self.getUrlVars(window.location.href);
		let dataTable:any = _self.$dealsDatatable;

		if (params['ddl']) {
			// create temporary input value for deals deep link
			// if input is detected on fromCountry select change,
			// other search params will not be reset to default values
			let ddlInput = $('<input id="ddl" type="hidden">');

			ddlInput.val(1);
			_self.$scope.append(ddlInput);
			ddlInput = $('input#ddl');

			// pass params to their respective search fields
			// do basic check of param value if matches expected syntax,
			// else return error in console

			// bBef: book before date (YYYYMMDD)
			if (params['bBef']) {
				let bBefVal:any = moment(params['bBef'], "YYYYMMDD");
				if (bBefVal._isValid) {
					bBefVal = moment(params['bBef'], "YYYYMMDD").format('DD MMM YYYY');
					dataTable.column(5).search(bBefVal).draw();
				} else {
						// throw console error
						console.error('malformed syntax params[bBef]');
				}

			}

			// toLoc: to location (city name)
			if (params['toLoc']) {
				let toLoc:string = decodeURI(params['toLoc']);

				_self.$scope.find('#datatable--destination-select')[0].selectize.setValue(toLoc);
			}

			// cabin: cabin type (F/B/E)
			if (params['cabin']) {
				let cabinVal:string;

				switch (params['cabin'].toLowerCase()) {
					case 'f':
						cabinVal = 'BUSINESS SUITE';
						break;
					case 'b':
						cabinVal = 'BUSINESS';
						break;
					case 'e':
						cabinVal = 'ECONOMY';
						break;
					default:
						cabinVal = 'All';
						// throw console error
						console.error('malformed syntax params[cabin]');
						break;
				}

				if (cabinVal.length) {
					_self.$scope.find('#datatable--cabin-select')[0].selectize.setValue(cabinVal);
				}
			}

			// tripType: trip type (R/O)
			if (params['tripType']) {
				let tripVal:string;

				switch (params['tripType'].toLowerCase()) {
					case 'r':
						tripVal = 'Return';
						break;
					case 'o':
						tripVal = 'One Way';
						break;
					default:
						tripVal = '';
						// throw console error
						console.error('malformed syntax params[tripType]');
						break;
				}

				if (tripVal.length) {
					_self.$scope.find('.trip-type [data-search-param="'+tripVal+'"]').click();
				}
			}

			// fromLoc: from location (3 letter country code)
			// set this last because it requires large dataset change
			if (params['fromLoc']) {
				let fromVal = params['fromLoc'].toUpperCase();

				if (fromVal.length && fromVal.length < 4) {
					_self.$scope.find('#datatable--country-select')[0].selectize.setValue(fromVal);
				} else {
					// throw console error
					console.error('malformed syntax params[fromLoc]');
				}
			}
		}
	}

	/**
   * get url params from url string
   * @param  {string} url [description]
   * @return {any} - returns an object which contains all url params searchable by params index and param key
   */
	getUrlVars(url:string):any {
	 	let vars:Array<any> = [],
	 			hash:any;
	 	let hashes:any = url.slice(url.indexOf('?') + 1).split('&');

	 	for (var i = 0; i < hashes.length; i++) {
	 		hash = hashes[i].split('=');
	 		vars.push(hash[0]);
	 		vars[hash[0]] = hash[1];
	 	}

	 	return vars;
	}
}



let scope:Element = document.querySelector('[data-fullpage-deals]');
if (scope){
	try {
	let dealsdetailed = new dealsDetailed();
			dealsdetailed.dealsInit();
			dealsdetailed.dealsButtonHandlers();
			dealsdetailed.tableBehaviorEffects();
			$(document).ready(function(){
				dealsdetailed.getDealsData().then((data:any) => {
					dealsdetailed.setCurrencyType(data);
					dealsdetailed.setDestCities(data);
					dealsdetailed.dealsTable(data);
					dealsdetailed.dealsSelect(data);
				});
			});
	} catch(e) {console.error(e);}
}
